import { Button, Form, Input, Select } from 'antd';
import React, { useEffect } from 'react';
import { useTransaction } from './TransactionStore';
import TextArea from 'antd/es/input/TextArea';
import { Option } from 'antd/es/mentions';

function Add(props) {
    let { addTransaction, getKontr, kontr } = useTransaction()
    // customer_id, transaction_type, amount, currency, status, transaction_date, description
    useEffect(() => {
        getKontr();
    }, [getKontr]);
    return (
        <Form layout='vertical' onFinish={addTransaction}>
            <Form.Item name={'customer_id'} label="Kontragent">
                <Select options={kontr.map((item) => ({ value: item.id, label: (item.kontr_type === 'customer' ? "Mijoz" : "Sotuvchi") + " | " + item.first_name + ' ' + item.last_name }))} />
            </Form.Item>
            <Form.Item name={'transaction_type'} label="Turi">
                <Select>
                    <Option value='debit'>Chiqim</Option>
                    <Option value='credit'>Kirim</Option>
                </Select>
            </Form.Item>
            <Form.Item name={'amount'} label="Summa">
                <Input type='number' />
            </Form.Item>
            <Form.Item name={'currency'} label="Valyuta">
                <Select>
                    <Option value='UZS'>Sum</Option>
                    <Option value='USD'>Dollar</Option>
                </Select>
            </Form.Item>
            <Form.Item name={'status'} label="Status">
                <Select>
                    <Option value='completed'>Bajarilgan</Option>
                    <Option value='pending'>Kutilmoqda</Option>
                    <Option value='failed'>Bekor qilingan</Option>
                </Select>
            </Form.Item>
            <Form.Item name={'transaction_date'} label="Bajarilgan vaqti">
                <Input type='date' />
            </Form.Item>
            <Form.Item name={'description'} label="Izoh">
                <TextArea />
            </Form.Item>
            <Form.Item>
                <Button type='primary' htmlType='submit'>Qo'shish</Button>
            </Form.Item>
        </Form>
    );
}

export default Add;